import { useState } from "react";
import { Button, Form, Input } from "antd";

import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";
import { GetUrlParams } from "scripts/helpers";

const Component = () => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { submitting } = state;
	const [form] = Form.useForm();
	const { mobile } = GetUrlParams(search);

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				API.auth
					.login(values)
					.then(({ token }) => {
						API.setCookie(token, 100000);
					})
					.catch(() => {
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
					});
			});
		}
	};

	const componentDidMount = () => {
		const { mobile } = GetUrlParams(search);

		if (Patterns.mobile.test(mobile)) {
			form.setFieldValue("phone", mobile);
		} else {
			navigate("/auth/login", { replace: true });
		}
	};

	useEffect(componentDidMount, []);

	return (
		<div className="wrapper">
			<img src="/images/logo-black.png" alt="Shop" className="brand" />
			<h1 className="heading">{`${Resources.enter} ${Resources.to} ${Resources.account}`}</h1>
			<Form form={form} layout="vertical">
				<Form.Item name="phone" label={Resources.mobile} rules={Rules.mobile}>
					<Input type="tel" size="large" placeholder={Resources.mobile} />
				</Form.Item>
				<Form.Item
					name="password"
					label={Resources.password}
					rules={Rules.password}
				>
					<Input
						type="password"
						size="large"
						placeholder={Resources.password}
					/>
				</Form.Item>
				<Form.Item style={{ paddingTop: 16 }}>
					<Button
						type="primary"
						size="large"
						loading={submitting}
						onClick={handleSubmit}
						block
					>
						{Resources.enter}
					</Button>
				</Form.Item>
			</Form>
		</div>
	);
};

export default Component;
